import fetch from './fetch'
import qs from 'qs'
import { Base64 } from 'js-base64'
import { encryptKey } from '@/config/global'
import { aesEncrypt } from '@/utils/util'

class AuthApi {
	public loginByUsername(userForm: any) {
		userForm.loginPass = aesEncrypt(userForm.loginPass, encryptKey)
		return fetch({
			url: 'injury/user/pc/login',
			method: 'post',
			data: qs.stringify(userForm),
			timeout: 30 * 1000,
		})
	}

	public logout() {
		return fetch({
			url: 'injury/user/logout',
		})
	}

	public getPermession() {
		return fetch({
			url: 'injury/user/getPermession',
		})
	}

	public forgotPwdValidateCode(form: any) {
		return fetch({
			url: 'injury/user/forgotPwdValidateCode',
			params: form,
		})
	}

	public setForgotPwd(form: any) {
		form.pwd = aesEncrypt(form.pwd, encryptKey)
		return fetch({
			url: 'injury/user/setForgotPwd',
			params: form,
		})
	}
	public setSwitch(form: any) {
		return fetch({
			url: 'injury/user/oauth/switch',
			method: 'post',
			params: form,
		})
	}
	public ldapLogin(userForm: any) {
		userForm.password = aesEncrypt(userForm.password, encryptKey)
		return fetch({
			url: 'injury/user/oauth/ldap/login',
			method: 'post',
			data: userForm,
			timeout: 30 * 1000,
		})
	}
	public ddLogin(form: any) {
		return fetch({
			url: 'injury/user/oauth/ding/login',
			method: 'post',
			data: form,
		})
	}
}

export default new AuthApi()
